import React, { useState, useEffect } from "react";
// Chakra imports
import {
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon
} from "@chakra-ui/react";
import { FaHandHolding, FaList, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import useGetMechanics from "../../hooks/useGetMechanics";
import CreateMechanic from "../../modals/CreateMechanic";
import EditMechanic from "../../modals/EditMechanic";
import Pagination from "./Pagination";
import { MySearchBar } from "./MySearchBar";
import MechanicHistory from "modals/MechanicHistory";
import LendHistory from "modals/LendHistory";



function MechanicsTable() { 
  const [ keyword, setKeyword ] = useState("");
    const [ page, setPage ] = useState(1); 
    const pageLimit = 12;
    let { 
      mechanics, 
      totalMechanics,
      setGettingMechanics, 
      gettingMechanics, 
      gettingMechanicsReqSuccess 
    } = useGetMechanics({ page, limit: pageLimit, keyword: keyword });
    const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
    const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
    const { isOpen: isOpenHistory, onOpen: onOpenHistory, onClose: onCloseHistory } = useDisclosure();
    const { isOpen: isOpenToolHistory, onOpen: onOpenToolHistory, onClose: onCloseToolHistory } = useDisclosure();
    const [ toEditUser, setToEditUser ] = useState(null);
  
  
    useEffect(() => {
      reloadPage();
    }, [page, keyword]);
  
    const reloadPage = () => {
      setGettingMechanics(true);
    }
  
    const selectEditItem = (id) => {
      const user = mechanics.find((c) => c.id === id);
      setToEditUser(user);
      onOpenEdit(true);
    }
  
    const selectHistoryItem = (id) => {
      const user = mechanics.find((c) => c.id === id);
      setToEditUser(user);
      onOpenHistory(true);
    }

    const selectToolHistoryItem = (id) => {
      const user = mechanics.find((c) => c.id === id);
      setToEditUser(user);
      onOpenToolHistory(true);
    }
  
    const textColor = useColorModeValue("gray.700", "white");

    return (
        <Card 
          w="100%"
          h={{ sm: "auto", lg: "auto" }}
          position="relative"
          borderRadius="15px"
          mt="24px"
        >

          <CardHeader p="6px 0px 22px 0px">
              <Flex w="100%"
              flexDirection={{
                  sm: "row",
                  md: "row",
              }}
              alignItems={{ xl: "center" }}>
              <Box marginRight={4}>
                  <Text fontSize="lg" color={textColor} fontWeight="bold" pb=".5rem">
                  Mechanics
                  </Text>
              </Box>
              <MySearchBar 
                keyword={keyword}
                setKeyword={setKeyword}
                onReload={reloadPage}
              />
              <Spacer />
              <Box>
                  <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                  Create New
                  </Button>
              </Box>
              </Flex>
          </CardHeader>
          <CardBody>
              <Flex direction="column" w="100%">
              <Table variant="simple" color={textColor}>
                  <Thead>
                  <Tr my=".8rem" pl="0px" color="gray.400">
                      <Th p={2} color="gray.400">Full Name</Th>
                      <Th p={2} color="gray.400">Mobile</Th>
                      <Th p={2} color="gray.400">Status</Th>
                      <Th p={2} color="gray.400">Actions</Th>
                  </Tr>
                  </Thead>
                  <Tbody>
                  {gettingMechanics ? 
                      <Tr my=".8rem" >
                      <Td minWidth={{ sm: "250px" }} pl="0px" colSpan={4}>
                          <Progress isIndeterminate />
                      </Td>
                      </Tr>
                      : mechanics.map((user) => {
                      return (
                          <Tr my=".8rem" pl="0px" key={`mech-${user.id}`}>
                            <Td p={2}>{user.firstName + ' ' + user.lastName}</Td>
                            <Td p={2}>{user.mobile}</Td>
                            <Td p={2}>{user.isDisabled 
                                ? <Text color={'red'}>disabled</Text>
                                : <Text color={'green'}>enabled</Text>}
                            </Td>
                            <Td p={2}>
                                <Button p="0px" bg="transparent" onClick={() => selectEditItem(user.id)}>
                                <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                    <Icon as={FaPencilAlt} me="4px" />
                                    <Text fontSize="xs" fontWeight="semibold">EDIT</Text>
                                </Flex>
                                </Button>


                                <Button p="0px" bg="transparent" onClick={() => selectHistoryItem(user.id)}>
                                <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                    <Icon as={FaList} me="4px" />
                                    <Text fontSize="xs" fontWeight="semibold">JOB HISTORY</Text>
                                </Flex>
                                </Button>



                                <Button p="0px" bg="transparent" onClick={() => selectToolHistoryItem(user.id)}>
                                <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                    <Icon as={FaHandHolding} me="4px" />
                                    <Text fontSize="xs" fontWeight="semibold">TOOL HISTORY</Text>
                                </Flex>
                                </Button>

                            </Td>
                          </Tr>
                      );
                      })
                  }
                  </Tbody>
              </Table>
              <Pagination 
                  totalItems={totalMechanics}
                  pageRows={pageLimit}
                  currentPage={page}
                  onPageChanged={setPage}
              />
              </Flex>


              
          </CardBody>


          <CreateMechanic 
            isOpen={isOpenCreate}
            onClose={onCloseCreate}
            successCallback={reloadPage} 
            isToolsClerk={true}
          />
            
          <EditMechanic 
            isOpen={isOpenEdit}
            onClose={() => {
              setToEditUser(null);
              onCloseEdit();
            }}
            successCallback={reloadPage}
            userData={toEditUser}
            isToolsClerk={true}
          />

          <MechanicHistory 
            isOpen={isOpenHistory}
            onClose={() => {
              setToEditUser(null);
              onCloseHistory();
            }}
            userData={toEditUser}
          />

          <LendHistory
            isOpen={isOpenToolHistory}
            onClose={() => {
              setToEditUser(null);
              onCloseToolHistory();
            }}
            mechanicId={toEditUser ? toEditUser.id : undefined}
          />
      </Card>
      );
}


export default MechanicsTable;
